import { render, staticRenderFns } from "./RecTableView.vue?vue&type=template&id=2d6b7837&scoped=true&"
import script from "./RecTableView.vue?vue&type=script&lang=js&"
export * from "./RecTableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b7837",
  null
  
)

export default component.exports